import { GET_EMAIL_NOTIFICATION_SUCCESS, GET_EMAIL_NOTIFICATION_REQUEST, GET_EMAIL_NOTIFICATION_FAILURE, } from "@/redux/actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const getEmailNotificationReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_EMAIL_NOTIFICATION_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case GET_EMAIL_NOTIFICATION_REQUEST:
            return Object.assign({}, state);
        case GET_EMAIL_NOTIFICATION_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        default:
            return state;
    }
};
export default getEmailNotificationReducer;
